import * as React from "react";
import { Navigate } from "react-router";

import { useContractFamiliesAccess } from "@/hooks/use-contract-families-access";
import { ContractFamiliesView } from "@/views/contract-families/page";

export const ContractFamiliesRouteGate: React.FC = () => {
  const { isResolved, hasContractFamilies } = useContractFamiliesAccess();

  if (!isResolved) return null;

  if (!hasContractFamilies) return <Navigate to="/snapshots" replace />;

  return <ContractFamiliesView />;
};
